import { render, staticRenderFns } from "./ArticleTitle.vue?vue&type=template&id=6b49c87c&scoped=true"
import script from "./ArticleTitle.vue?vue&type=script&lang=js"
export * from "./ArticleTitle.vue?vue&type=script&lang=js"
import style0 from "./ArticleTitle.vue?vue&type=style&index=0&id=6b49c87c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b49c87c",
  null
  
)

export default component.exports